export function forceDownloadFromUrl(url: string) {
    if (url.endsWith('.pdf')) {
        window.open(url, '_blank');
    } else {
        const a = document.createElement('a');
        a.href = url;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
}